import React, { Component, Fragment } from 'react';
import Alert from 'react-bootstrap/Alert';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import noop from '../../utils/noop';
import hasQuotaData from '../../utils/hasQuotaData';

import RegularUsersQuotaReportOverviewCard from '../RegularUsersQuotaReportOverviewCard';
import EnterpriseUsersQuotaReportOverviewCard from '../EnterpriseUsersQuotaReportOverviewCard';
import ExternalUsersQuotaReportOverviewCard from '../ExternalUsersQuotaReportOverviewCard';
import EmployeeUsersQuotaReportOverviewCard from '../EmployeeUsersQuotaReportOverviewCard';

class QuotaSummaryUsersConsumption extends Component {
  hasQuotaReportData() {
    const { quotaReportData } = this.props;

    for (const usersField of ['regularUsers', 'enterpriseUsers', 'externalUsers', 'employeeUsers']) {
      if (hasQuotaData(quotaReportData, usersField))
        return true;
    }

    return false;
  }

  shouldRenderSummary() {
    const { shouldRenderSummary } = this.props;

    return (
      shouldRenderSummary &&
      (this.hasQuotaReportData())
    );
  }

  doesNotHaveQuota() {
    const { quotaReportData } = this.props;

    return (
      quotaReportData &&
      quotaReportData.quota &&
      !quotaReportData.quota.regularUsers &&
      !quotaReportData.quota.enterpriseUsers &&
      !quotaReportData.quota.externalUsers &&
      !quotaReportData.quota.employeeUsers
    );
  }

  renderUsersOverview() {
    return (
      <Fragment key="users-overview">
        {this.doesNotHaveQuota() ? (
          <Alert variant="warning" key="alert">
            No Quota Utilization information is available for this tenant.
          </Alert>
        ) : (
          <Fragment key="users-reports">
            <RegularUsersQuotaReportOverviewCard key="regular-users" {...this.props} />
            <EnterpriseUsersQuotaReportOverviewCard key="enterprise-users" {...this.props} />
            <ExternalUsersQuotaReportOverviewCard key="external-users" {...this.props} />
            <EmployeeUsersQuotaReportOverviewCard key="employees" {...this.props} />
          </Fragment>
        )}
      </Fragment>
    );
  }

  render() {
    const { isAppliance } = this.props;

    return (
      <div>
        {this.shouldRenderSummary() ? (
          <div>
            <h2 className="report-overview-card-title">User Consumption</h2>
            {isAppliance && (
              <p className="report-overview-card-subtitle">
                These reports show quota consumption in both Private Instance and
                Cloud tenants.
              </p>
            )}
            <div className="report-overview-card-container">
              {
                this.renderUsersOverview()
              }
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

QuotaSummaryUsersConsumption.propTypes = {
  shouldRenderSummary: PropTypes.bool,
  quotaReportData: PropTypes.object,
  showReportDetails: PropTypes.func,
  contactSales: PropTypes.func,
  contactSalesLink: PropTypes.string,
  isAppliance: PropTypes.bool,
  isMixedPlan: PropTypes.bool
};

QuotaSummaryUsersConsumption.defaultProps = {
  showReportDetails: noop,
  quotaReportData: {},
  enterpriseConnectionsReportData: {}
};

export default QuotaSummaryUsersConsumption;
